import HTTP_ERP from '@/config/axios-config-erp'
const ServicesAuth = {
  getTokenInfo (payload) {
    return HTTP_ERP.post('wscomun/usuario/datosUsuario', payload).catch(err => {
      throw err
    })
  }
} 

export default ServicesAuth
